export const toLocaleString = num =>
	num.toString().replace(/(?<!\..*)(\d)(?=(?:\d{3})+(?:\.|$))/g, '$1 ');

export const removeSpaces = num => num.toString().replace(/\s/g, '');

export const math = (a, b, sign) =>
	sign === '+' ? a + b : sign === '-' ? a - b : sign === 'X' ? a * b : a / b;